<flx-modal
  [dismissible]="true"
  (dismiss)="closeModal()"
  class="flx-ds confirmation"
>
  <div
    class="flx-modal-title"
    flxModalHeaderTitle
  >
    Delete type <span class="font-semibold">{{ data.entity?.name }}</span>
  </div>

  @if (data.references.length) {
    <div class="flx-modal-body">
      <div class="text-sm text-neutral-700">
        Your action will affect
        <span class="font-semibold">{{ data.entity.name }}</span> entity definition. Check below the
        references and relationships where
        <span class="font-semibold">{{ data.entity.name }}</span> entity is being used.
      </div>

      <div class="flex flex-col gap-2">
        @for (path of data.references; track path) {
          <flx-entity-references
            [isCollapsable]="$count > 1 && path.attributeReferences.length > 0"
            [references]="path.attributeReferences"
            [path]="path.path"
            [resourceType]="data.resourceType"
          ></flx-entity-references>
        }
      </div>
    </div>
  }

  <div class="flx-modal-footer">
    <div class="flx-modal-footer__right">
      <button
        (click)="closeModal()"
        class="flx-ds secondary"
        flxButton
        type="button"
        data-testId="confirmation-modal-cancel-button"
      >
        Cancel
      </button>
      <button
        (click)="confirm()"
        class="flx-ds primary danger"
        flxButton
        type="button"
        data-testId="confirmation-modal-confirm-button"
      >
        Delete
      </button>
    </div>
  </div>
</flx-modal>
